import * as React from 'react';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';

import Listings from '../../utility/Listings';
import NoResults from '../../utility/NoResults';
import styles from './styles';

interface Props {
  classes: any;
  listings: any;
}

export const Similar = (props: Props) => {
  const { classes, listings } = props;
  return (
    <div className={classes.similarContainer}>
      {listings.length === 0 && (
        <NoResults
          emptyText="No Similar Properties are currently available."
          bottomText
          padTop
        />
      )}
      {listings.length > 0 && (
        <Listings
          allowFavorite={false}
          listings={listings}
          narrow={false}
          showDelete={false}
          key={listings.length}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  listings: state.comps.relatedListings,
});

export default connect(mapStateToProps)(withStyles(styles)(Similar));
